export default "__VITE_ASSET__9823e93f__"